import { Box, Typography } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import PillButton from 'components/atoms/Buttons/PillButton';
import useAuth from 'hooks/useAuth';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Store } from 'redux/store';
import { setDrawerStateRedux } from 'redux/ui/imgComparation/actions';
import { getSessionStorage } from 'utility/browserStorageUtil';
import SidebarItem from './SidebarItem';
import useStyles from './styles';
import { SidebarMenu } from './type';


export default React.memo(() => {
  const classes = useStyles();
  const companyCode = getSessionStorage('companyCode') || '';
  const companyName = getSessionStorage('companyName') || '';
  const mediumSizeIcon = {
    width: '36px',
    height: '36px',
  };

  const { signout } = useAuth();
  const {
    staffDetail,
    roles: {
      orgAccess, exeAccess, staffAccess, roleAccess,
      employAccess, customerAccess, customerManagerSetting,
      reservationStoreSetting,
      reservationManagement, reservationManagementSetting,
      reservationAgentMaster, reservationCreativeMaster, reservationMediaPlacement,
      reservationInquiry, reservationAreaMaster, reservationNewCourseMaster,
      reservationExistingCourseMaster, reservationAssignSetting,
      reservationMailSetting, reservationShiftSchedule, reservationShiftManagement,
      commonSalesMenuSection, commonSalesMenu, commonContractMenuClass,
      commonContractMenu, commonContractCourseClass, commonContractCourseCategory,
      commonContractCourse, commonRegisterMedium, commonRegisterMediumSubClass,
      commonRegisterRate, commonRegisterDiscount, commonPointSetting, commonStockPurchase,
      registerStoreSetting, registerHeadquartersSetting, registerManagement,
      contractStatus, contractFlatRate, revenueShopBudgetSetting, contractAutoCreateHistory, contractAutoTicketUseHistory,
      revenueSalesDailyReport, revenueSalesMonthlyReport, revenueDailyTotal,
      revenueSalesMonthlyReportList, revenuePersonal, revenueSalesMedia, revenueHeadquarterBudgetSetting, revenueAdReport, revenueSalesStoreMedia, revenueSalesCourse,
      revenueShopItem, revenueExpensiveUsedCustomer, revenueIncentive, revenueContinuousRate,
      revenueReservationAdvertisingMedia, revenueAccountReceivable, revenuePointUse,
      revenuePointRemain, revenuePointUseRateReport, revenueDailyTotalList, revenueSimpleSalesSimulation, inventoryControl, mailManagement, approvalManagement, workflowHeadquartersSetting,

    },
  } = useSelector((reduxState: Store) => reduxState.auth);
  const { drawerState } = useSelector((reduxState: Store) => reduxState.ui.imagelist);
  const dispatch = useDispatch();

  const commonAccess = ((!!commonSalesMenuSection && !commonSalesMenuSection?.isDisabled)
  || (!!commonSalesMenu && !commonSalesMenu?.isDisabled)
  || (!!commonContractMenuClass && !commonContractMenuClass?.isDisabled)
  || (!!commonContractMenu && !commonContractMenu?.isDisabled)
  || (!!commonContractCourseClass && !commonContractCourseClass?.isDisabled)
  || (!!commonContractCourseCategory && !commonContractCourseCategory?.isDisabled)
  || (!!commonContractCourse && !commonContractCourse?.isDisabled)
  || (!!commonRegisterMedium && !commonRegisterMedium?.isDisabled)
  || (!!commonRegisterMediumSubClass && !commonRegisterMediumSubClass?.isDisabled)
  || (!!commonRegisterRate && !commonRegisterRate?.isDisabled)
  || (!!commonRegisterDiscount && !commonRegisterDiscount?.isDisabled)
  || (!!commonStockPurchase && !commonStockPurchase?.isDisabled)
  || (!!commonPointSetting && !commonPointSetting?.isDisabled));


  const revenueAccess = ((!!revenueShopBudgetSetting && !revenueShopBudgetSetting?.isDisabled)
  || (!!revenueSalesDailyReport && !revenueSalesDailyReport?.isDisabled)
  || (!!revenueSalesMonthlyReport && !revenueSalesMonthlyReport?.isDisabled)
  || (!!revenueDailyTotal && !revenueDailyTotal?.isDisabled)
  || (!!revenueSalesMonthlyReportList && !revenueSalesMonthlyReportList?.isDisabled)
  || (!!revenuePersonal && !revenuePersonal?.isDisabled)
  || (!!revenueSalesMedia && !revenueSalesMedia?.isDisabled)
  || (!!revenueSalesStoreMedia && !revenueSalesStoreMedia?.isDisabled)
  || (!!revenueSalesCourse && !revenueSalesCourse?.isDisabled)
  || (!!revenueShopItem && !revenueShopItem?.isDisabled)
  || (!!revenueExpensiveUsedCustomer && !revenueExpensiveUsedCustomer?.isDisabled)
  || (!!revenueIncentive && !revenueIncentive?.isDisabled)
  || (!!revenueContinuousRate && !revenueContinuousRate?.isDisabled)
  || (!!revenueReservationAdvertisingMedia && !revenueReservationAdvertisingMedia?.isDisabled)
  || (!!revenueAccountReceivable && !revenueAccountReceivable?.isDisabled)
  || (!!revenuePointUse && !revenuePointUse?.isDisabled)
  || (!!revenuePointRemain && !revenuePointRemain?.isDisabled)
  || (!!revenuePointUseRateReport && !revenuePointUseRateReport?.isDisabled)
  || (!!revenueDailyTotalList && !revenueDailyTotalList?.isDisabled)
  || (!!revenueSimpleSalesSimulation && !revenueSimpleSalesSimulation?.isDisabled)
  || (!!revenueHeadquarterBudgetSetting && !revenueHeadquarterBudgetSetting?.isDisabled)
  || (!!revenueAdReport && !revenueAdReport?.isDisabled));

  const handleCloseOpenClick = () => {
    dispatch(setDrawerStateRedux(!drawerState));
  };

  const sidebarItems: SidebarMenu[] = [
    {
      title: 'ホーム',
      accessible: true,
      link: '/',
    },
    {
      title: '顧客管理',
      accessible: !!customerAccess && !customerAccess?.isDisabled,
      items: [
        {
          title: '顧客情報一覧',
          link: '/customer',
          accessible: !!customerAccess && !customerAccess?.isDisabled,
        },
        {
          title: '本部設定',
          accessible: ([...staffDetail?.featureSettings].filter((item) => item?.id?.featureCategory === 1)?.[0]?.useManagerSetting && customerManagerSetting?.edit) ?? false,
          isChild: true,
          items: [
            {
              title: '　顧客番号ﾌｫｰﾏｯﾄ設定',
              link: '/formatNumber',
              accessible: ([...staffDetail?.featureSettings].filter((item) => item?.id?.featureCategory === 1)?.[0]?.useManagerSetting && customerManagerSetting?.edit) ?? false, // customerManagerSetting
              isChild: true,
            },
            {
              title: '　添付シート区分設定',
              link: '/attachedSheetClassificationSetting',
              accessible: ([...staffDetail?.featureSettings].filter((item) => item?.id?.featureCategory === 1)?.[0]?.useManagerSetting && customerManagerSetting?.edit) ?? false,
              isChild: true,
            },
            {
              title: '　反響情報拡張設定',
              link: '/customerReverberationInfoExSetting',
              accessible: ([...staffDetail?.featureSettings].filter((item) => item?.id?.featureCategory === 1)?.[0]?.useManagerSetting && customerManagerSetting?.edit) ?? false,
              isChild: true,
            },
          ],
        },
      ],
    },
    {
      title: '予約管理',
      accessible: !!reservationManagement && !reservationManagement?.isDisabled,
      items: [
        {
          title: '予約表',
          link: '/reservation',
          accessible: !!reservationManagement && !reservationManagement?.isDisabled,
        },
        {
          title: '予約問い合わせ',
          link: '/reservationInquiryList',
          accessible: !!reservationInquiry?.edit,
        },
        {
          title: '本部管理設定',
          link: '/headQuarters',
          accessible: ([...staffDetail?.featureSettings].filter((item) => item?.id?.featureCategory === 2)?.[0]?.useManagerSetting && reservationManagementSetting?.edit) ?? false,
        },
        {
          title: 'エリアマスタ',
          link: '/areaMst',
          accessible: !!reservationAreaMaster?.edit,
        },
        {
          title: '店舗設定',
          link: `/reservationManagement/storeSetting/${staffDetail.orgId}`,
          accessible: ([...staffDetail?.featureSettings].filter((item) => item?.id?.featureCategory === 2)?.[0]?.useGeneralSetting && reservationStoreSetting?.edit) ?? false,
        },
        {
          title: '新規予約コースマスタ',
          link: '/reservationManagement/newCustomers',
          accessible: !!reservationNewCourseMaster?.edit,
        },
        {
          title: '既存予約コースマスタ',
          link: '/reservationManagement/existingCustomers',
          accessible: !!reservationExistingCourseMaster?.edit,
        },
        {
          title: 'アサイン設定',
          link: '/reservationManagement/assignSetting',
          accessible: !!reservationAssignSetting?.edit,
        },
        {
          title: '予約メール設定',
          link: `/reservationManagement/reservationMailSetting/${staffDetail.orgId}`,
          accessible: !!reservationMailSetting?.edit,
        },
        {
          title: 'シフト管理',
          accessible: !!reservationShiftSchedule?.edit || !!reservationShiftManagement?.edit,
          items: [
            {
              title: '　シフト表',
              link: '/shiftManagement',
              accessible: !!reservationShiftSchedule?.edit,
              isChild: true,
            },
            {
              title: '　一括登録',
              link: '/shiftBulkRegistration',
              accessible: !!reservationShiftManagement?.edit,
              isChild: true,
            },
            {
              title: '　シフトパターン',
              link: '/shiftPattern',
              accessible: !!reservationShiftManagement?.edit,
              isChild: true,
            },
          ],
        },
        {
          title: '広告設定',
          accessible: !!reservationAgentMaster?.edit
            || !!reservationCreativeMaster?.edit
            || !!reservationMediaPlacement?.edit,
          items: [
            {
              title: '　代理店マスタ',
              link: '/agentMaster',
              accessible: !!reservationAgentMaster?.edit,
              isChild: true,
            },
            {
              title: '　クリエイティブ・・',
              link: '/creativeMaster',
              accessible: !!reservationCreativeMaster?.edit,
              isChild: true,
            },
            {
              title: '　効果測定URL発行',
              link: '/mediaPlacement',
              accessible: !!reservationMediaPlacement?.edit,
              isChild: true,
            },
          ],
        },
      ],
    },
    {
      title: 'POSレジ',
      accessible: !!registerManagement && !registerManagement?.isDisabled,
      items: [
        {
          title: '会計入力',
          link: '/pos',
          accessible: true,
        },
        {
          title: '本部設定',
          accessible: (!!registerHeadquartersSetting && !registerHeadquartersSetting?.isDisabled),
          isChild: true,
          items: [
            {
              title: '　レシートロゴ設定',
              link: '/receiptLogoSetting',
              accessible: true,
              isChild: true,
            },
            {
              title: '　レジ基本設定',
              link: '/cashierBasicSetting',
              accessible: true,
              isChild: true,
            },
            {
              title: '　支払方法設定',
              link: '/paymentMethod',
              accessible: true,
              isChild: true,
            },
            {
              title: '　カード会社設定',
              link: '/cardCompanySetting',
              accessible: true,
              isChild: true,
            },
          ],
        },
        {
          title: '店舗設定',
          accessible: (!!registerStoreSetting && !registerStoreSetting?.isDisabled),
          isChild: true,
          items: [
            {
              title: '　レジ使用店舗設定',
              link: '/cashierStoreSetting',
              accessible: true,
              isChild: true,
            },
            {
              title: '　レシートCM設定',
              link: '/receiptCMSetting',
              accessible: true,
              isChild: true,
            },
            {
              title: '　バーコード印刷',
              link: '/barcodePrinting',
              accessible: true,
              isChild: true,
            },
          ],
        },
      ],
    },
    {
      title: '契約管理',
      accessible: (!!contractStatus && !contractStatus?.isDisabled) || (!!contractFlatRate && !contractFlatRate?.isDisabled),
      items: [
        {
          title: '契約状況',
          link: '/contractStatus',
          accessible: !!contractStatus,
        },
        {
          title: '定額制契約一覧',
          link: '/listOfFlatRateContracts',
          accessible: (!!contractFlatRate && !contractFlatRate?.isDisabled),
        },
        {
          title: '定額制契約自動作成履歴',
          link: '/flatRateContractAutomaticCreationHistory',
          accessible: (!!contractAutoCreateHistory && !contractAutoCreateHistory?.isDisabled),
        },
        {
          title: '定額制契約自動消化履歴',
          link: '/flatRateContractAutomaticDigestionHistory',
          accessible: (!!contractAutoTicketUseHistory && !contractAutoTicketUseHistory?.isDisabled),
        },
      ],
    },
    {
      title: '売上管理',
      accessible: !!revenueAccess,
      items: [
        {
          title: '日次集計レポート',
          link: '/dailySummaryReport',
          accessible: (!!revenueSalesDailyReport && !revenueSalesDailyReport?.isDisabled),
        },
        {
          title: '営業月報レポート',
          link: '/monthlyReport',
          accessible: (!!revenueSalesMonthlyReport && !revenueSalesMonthlyReport?.isDisabled),
        },
        {
          title: '個人別売上レポート',
          link: '/individualSalesReport',
          accessible: (!!revenuePersonal && !revenuePersonal?.isDisabled),
        },
        {
          title: '営業月報（リスト）',
          link: '/monthlyBusinessReport',
          accessible: (!!revenueSalesMonthlyReportList && !revenueSalesMonthlyReportList?.isDisabled),
        },
        {
          title: '日計レポート',
          link: '/dailyList',
          accessible: (!!revenueDailyTotal && !revenueDailyTotal?.isDisabled),
        },
        {
          title: '媒体別売上レポート',
          link: '/mediaList',
          accessible: (!!revenueSalesMedia && !revenueSalesMedia?.isDisabled),
        },
        {
          title: '広告集計レポート',
          link: '/mediaAgentReport',
          accessible: (!!revenueAdReport && !revenueAdReport?.isDisabled),
        },
        {
          title: '本部設定',
          accessible: (!!revenueHeadquarterBudgetSetting && !revenueHeadquarterBudgetSetting?.isDisabled),
          isChild: true,
          items: [
            {
              title: '　広告費入力画面',
              link: '/mediaAdCost',
              accessible: (!!revenueHeadquarterBudgetSetting && !revenueHeadquarterBudgetSetting?.isDisabled),
              isChild: true,
            },
            {
              title: '　年度設定',
              link: '/fiscalYearSetting',
              accessible: (!!revenueHeadquarterBudgetSetting && !revenueHeadquarterBudgetSetting?.isDisabled),
              isChild: true,
            },
          ],
        },
        {
          title: '店舗別媒体売上レポート',
          link: '/mediaByStoreList',
          accessible: (!!revenueSalesStoreMedia && !revenueSalesStoreMedia?.isDisabled),
        },
        {
          title: 'コース別売上レポート',
          link: '/courseListReport',
          accessible: (!!revenueSalesCourse && !revenueSalesCourse?.isDisabled),
        },
        {
          title: '店販品レポート',
          link: '/saleItemsReport',
          accessible: (!!revenueShopItem && !revenueShopItem?.isDisabled),
        },
        {
          title: '高額利用顧客レポート',
          link: '/vipClientReport',
          accessible: (!!revenueExpensiveUsedCustomer && !revenueExpensiveUsedCustomer?.isDisabled),
        },
        {
          title: 'インセンティブレポート',
          link: '/incentiveReport',
          accessible: (!!revenueIncentive && !revenueIncentive?.isDisabled),
        },
        {
          title: '継続率レポート',
          link: '/continuationRateReport',
          accessible: (!!revenueContinuousRate && !revenueContinuousRate?.isDisabled),
        },
        {
          title: '未収金一覧',
          link: '/listUncollectedMoney',
          accessible: (!!revenueAccountReceivable && !revenueAccountReceivable?.isDisabled),
        },
        // {
        //   title: '予約広告媒体',
        //   link: '/',
        //   accessible: (!!revenueReservationAdvertisingMedia && !revenueReservationAdvertisingMedia?.isDisabled),
        // },
        {
          title: 'ポイント利用レポート',
          link: '/pointUsageReport',
          accessible: (!!revenuePointUse && !revenuePointUse?.isDisabled),
        },
        {
          title: 'ポイント残高レポート',
          link: '/pointBalanceReport',
          accessible: (!!revenuePointRemain && !revenuePointRemain?.isDisabled),
        },
        {
          title: 'ポイント利用率レポート',
          link: '/pointUseRateReport',
          accessible: (!!revenuePointUseRateReport && !revenuePointUseRateReport?.isDisabled),
        },
        {
          title: '日計一覧（店舗別）',
          link: '/dailyTotalListByStore',
          accessible: (!!revenueDailyTotalList && !revenueDailyTotalList?.isDisabled),
        },
        {
          title: '簡易売上シュミレー・・',
          link: '/simpleSalesSimulationReport',
          accessible: (!!revenueSimpleSalesSimulation && !revenueSimpleSalesSimulation?.isDisabled),
        },
        {
          title: '店舗設定',
          accessible: (!!revenueShopBudgetSetting && !revenueShopBudgetSetting?.isDisabled),
          isChild: true,
          items: [
            {
              title: '　店舗予算設定',
              link: '/storeBudgeSetting',
              accessible: (!!revenueShopBudgetSetting && !revenueShopBudgetSetting?.isDisabled),
              isChild: true,
            },
          ],
        },
      ],
    },
    {
      title: '在庫管理',
      accessible: (!!inventoryControl && !inventoryControl?.isDisabled),
      items: [
        {
          title: '店販 / 販促一覧',
          link: '/salesAndPromotionList',
          accessible: true,
        },
        {
          title: '業務出荷情報入力',
          link: '/enterInternalExportInformation',
          accessible: true,
        },
        {
          title: '入荷情報入力',
          link: '/enterArrivalInformation',
          accessible: true,
        },
        {
          title: '在庫一覧',
          link: '/inventoryList',
          accessible: true,
        },
        {
          title: '店舗別在庫一覧',
          link: '/inventoryByStoreList',
          accessible: true,
        },
      ],
    },
    {
      title: 'メルマガ管理',
      accessible: (!!mailManagement && !mailManagement?.isDisabled),
      items: [
        {
          title: 'メルマガ配信',
          link: '/maiMagazineList',
          accessible: (!!mailManagement && !mailManagement?.isDisabled),
        },
      ],
    },
    {
      title: '稟議管理',
      accessible: (!!approvalManagement && !approvalManagement?.isDisabled),
      items: [
        {
          title: '稟議文書一覧',
          link: '/approvalDocumentList',
          accessible: (!!approvalManagement && !approvalManagement?.isDisabled),
        },
        {
          title: '要承認一覧',
          link: '/admitApplicationList',
          accessible: (!!approvalManagement && !approvalManagement?.isDisabled),
        },
        {
          title: '要申請一覧',
          link: '/requiredApplicationList',
          accessible: (!!approvalManagement && !approvalManagement?.isDisabled),
        },
        {
          title: '結果一覧',
          link: '/resultList',
          accessible: (!!approvalManagement && !approvalManagement?.isDisabled),
        },
        {
          title: '参照一覧',
          link: '/applicationApprovalReferenceList',
          accessible: (!!approvalManagement && !approvalManagement?.isDisabled),
        },
        {
          title: '新規申請',
          link: '/applicationDocument',
          accessible: (!!approvalManagement && !approvalManagement?.isDisabled),
        },
        {
          title: '本部設定',
          accessible: (!!workflowHeadquartersSetting && !workflowHeadquartersSetting?.isDisabled && workflowHeadquartersSetting?.edit),
          isChild: true,
          items: [
            {
              title: '　組織略称設定',
              link: '/organizationAbbreviationSetting',
              accessible: true,
              isChild: true,
            },
            {
              title: '　申請番号ﾌｫｰﾏｯﾄ設定',
              link: '/formatNumberApproval',
              accessible: true,
              isChild: true,
            },
            {
              title: '　稟議文書マスタ',
              link: '/approvalDocumentMaster',
              accessible: true,
              isChild: true,
            },
            {
              title: '　申請ルートマスタ',
              link: '/applicationRoute',
              accessible: true,
              isChild: true,
            },
            {
              title: '　ルート割当',
              link: '/approvalRouteAssignment',
              accessible: true,
              isChild: true,
            },
          ],
        },
      ],
    },
    {
      title: '基本マスタ設定',
      accessible: (!!orgAccess && !orgAccess?.isDisabled) || (!!exeAccess && !exeAccess?.isDisabled) || (!!roleAccess && !roleAccess?.isDisabled) || (!!staffAccess && !staffAccess?.isDisabled) || (!!employAccess && !employAccess?.isDisabled),
      items: [
        {
          title: '組織マスタ',
          link: '/orgMaster',
          accessible: (!!orgAccess && !orgAccess?.isDisabled),
        },
        {
          title: '役職マスタ',
          link: '/executiveMaster',
          accessible: (!!exeAccess && !exeAccess?.isDisabled),
        },
        {
          title: '権限マスタ',
          link: '/roleMaster',
          accessible: (!!roleAccess && !roleAccess?.isDisabled),
        },
        {
          title: 'スタッフマスタ',
          link: '/staffMaster',
          accessible: (!!staffAccess && !staffAccess?.isDisabled),
        },
        {
          title: '雇用形態マスタ',
          link: '/employmentMaster',
          accessible: (!!employAccess && !employAccess?.isDisabled),
        },
      ],
    },
    {
      title: '共通マスタ設定',
      accessible: !!commonAccess,
      items: [
        {
          title: 'メニュー分類マスタ',
          link: '/menuClassificationMaster',
          accessible: (!!commonContractMenuClass && !commonContractMenuClass?.isDisabled),
        },
        {
          title: 'メニューマスタ',
          link: '/menuMaster',
          accessible: (!!commonContractMenu && !commonContractMenu?.isDisabled),
        },
        {
          title: 'コース分類マスタ',
          link: '/courseGroupMaster',
          accessible: (!!commonContractCourseClass && !commonContractCourseClass?.isDisabled),
        },
        {
          title: 'コースカテゴリマスタ',
          link: '/courseCategoryMaster',
          accessible: (!!commonContractCourseCategory && !commonContractCourseCategory?.isDisabled),
        },
        {
          title: 'コースマスタ',
          link: '/courseMaster',
          accessible: (!!commonContractCourse && !commonContractCourse?.isDisabled),
        },
        {
          title: '媒体設定',
          link: '/mediaMaster',
          accessible: (!!commonRegisterMedium && !commonRegisterMedium?.isDisabled),
        },
        {
          title: '仕入先設定',
          link: '/supplierMaster',
          accessible: (!!commonStockPurchase && !commonStockPurchase?.isDisabled),
        },
        {
          title: '商品部門設定',
          link: '/productDepartment',
          accessible: (!!commonSalesMenuSection && !commonSalesMenuSection?.isDisabled),
        },
        {
          title: '商品設定',
          link: '/productSetting',
          accessible: (!!commonSalesMenu && !commonSalesMenu?.isDisabled),
        },
        {
          title: '税率設定',
          link: '/taxRateSetting',
          accessible: (!!commonRegisterRate && !commonRegisterRate?.isDisabled),
        },
        {
          title: '値引・割引種別設定',
          link: '/discountType',
          accessible: (!!commonRegisterDiscount && !commonRegisterDiscount?.isDisabled),
        },
        {
          title: 'ポイント設定',
          link: '/pointSetting',
          accessible: (!!commonPointSetting && !commonPointSetting?.isDisabled),
        },
      ],
    },
    {
      title: 'ヘルプページ',
      accessible: true,
      anchor: 'https://win-board-help.zendesk.com/hc/ja',
    },
  ];

  return (
    <Drawer
      variant="permanent"
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: drawerState,
        [classes.drawerClose]: !drawerState,
      })}
      classes={{
        root: classes.drawer,
        paper: clsx({
          [classes.drawerPaper]: true,
          [classes.drawerOpen]: drawerState,
          [classes.drawerClose]: !drawerState,
        }),
      }}
    >
      <Box className={classes.toolbar}>
        <Box>
          <Box className={classes.logo}>
            <Box
              style={{
                visibility: drawerState ? 'visible' : 'hidden',
                minWidth: '150px',
                minHeight: '1px',
              }}
            >
              <img
                src={`/img/logo/logo_${companyCode}.png`}
                alt=""
              />
              <Typography className={classes.logoName}><strong>{companyName}</strong></Typography>
              <Typography className={classes.staffName}>{`${staffDetail.staffName}`}</Typography>
            </Box>
            <Box width="30px" display="flex">
              <IconButton
                className={clsx(classes.iconButton, {
                  [classes.iconButtonOpen]: drawerState,
                  [classes.iconButtonClose]: !drawerState,
                })}
                onClick={handleCloseOpenClick}
              >
                {drawerState ? <CloseIcon style={mediumSizeIcon} /> : <MenuIcon style={mediumSizeIcon} />}
              </IconButton>
            </Box>
          </Box>

          <List className={classes.list}>
            {sidebarItems.filter((item) => item.accessible && drawerState).map((menuItem, i) => (
              <SidebarItem
                key={menuItem.title + String(i)}
                menuItem={menuItem}
              />
            ))}
          </List>
        </Box>

        <Box margin="1rem auto">
          <PillButton
            variant="contained"
            color="default"
            className={classes.logoutButton}
            style={{ display: drawerState ? '' : 'none' }}
            onClick={signout}
          >
            <strong>ログアウト</strong>
          </PillButton>
        </Box>
      </Box>
    </Drawer>
  );
});
